var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},_vm._l((_vm.area),function(object,key){return _c('div',{key:key,class:_vm.classify(key),style:(_vm.getStyle(object.totalFailures)),on:{"dblclick":function($event){_vm.acivateErrorsDetailsModal(object)}}},[(key !== 'totalFailures')?_c('span',[_vm._v("\n        "+_vm._s(object.totalFailures)+"\n      ")]):_vm._e()])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-152632d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ErrorBar.vue
// module id = null
// module chunks = 